import {
    makeStyles,
    styled,
    Switch as SwitchDefault,
    ListItemText as ListItemTextDefault
} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        background: 'white',
        paddingTop: 5,
        paddingBottom: 5,
        maxWidth: 600,
        width: '95%',
        borderRadius: 15,
        margin: '20px 0',
        '-webkit-box-shadow': '0px 4px 4px 0px rgba(191,187,191,1)',
        '-moz-box-shadow': '0px 4px 4px 0px rgba(191,187,191,1)',
        boxShadow: '0px 4x 4px 0px rgba(191,187,191,1)'
    },
    wrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', // TODO: check if we can remove this
        alignItems: 'center',
        fontSize: 12,
        height: 60,
        cursor: 'pointer',
        textAlign: 'center',
        flex: 1
    },
    disableWrapper: {
        opacity: 0.5
    },
    iconWrapper: {
        height: 38,
        paddingTop: 6
    },
    icon: {
        cursor: 'pointer'
    },

    dropdown: {
        marginTop: 5,
        maxWidth: 350,
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border
    },
    datePickerWrapper: {
        display: 'flex',
        gap: 10,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8
    },
    datePickerGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginBottom: 16,
        marginTop: 16,
        marginLeft: 16,
        marginRight: 16
    },
    datePicker: {
        borderRadius: theme.borderRadius,
        border: theme.border,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiInput-underline:before': {
            content: 'none'
        },
        '& .MuiInput-underline:after': {
            content: 'none'
        },
        '& .MuiInputBase-input': {
            padding: '14px 8px',
            display: 'none'
        },
        '& .calendarIcon': {
            ...calendarIcon
        }
    },
    datePickerInput: {
        fontSize: 14,
        height: 40,
        width: 150,
        borderRadius: '4px'
    },
    datePickerInputLabel: {
        transform: 'translate(14px, 9px) scale(1)',
        paddingTop: 2
    },
    checkboxContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.borderRadius,
        border: theme.border,
        height: 40,
        width: '90%',
        marginLeft: 'auto', // Auto margin on the left and right for centering
        marginRight: 'auto',
        paddingLeft: 5,
        paddingRight: 5,
        '& .MuiInput-underline:before': {
            content: 'none' // Remove the default underline
        },
        '& .MuiInput-underline:after': {
            content: 'none' // Remove the default underline
        },
        zIndex: 9999,
        '& .MuiChip-label': {
            fontSize: 10
        }
    },

    buttonApplyFilter: {
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
        width: '75%',
        marginTop: 16,
        marginBottom: 16,
        marginLeft: 'auto', // Auto margin on the left and right for centering
        marginRight: 'auto'
    },
    dropdownCustomWrapper: {
        position: 'relative',
        minWidth: 120,
        zIndex: 9999
        /* TODO (to verify the change) position: 'absolute',
        minWidth: 120 */
    },
    heatmapTypeDropdownWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    heatmapTypeDropdown: {
        display: 'flex',
        flexDirection: 'column',
        padding: 16
    },
    dropdown2: {
        width: 20,
        marginTop: -5,
        marginLeft: -10,
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border
    },
    dropdownCustomComponent: {
        maxWidth: 350,
        marginTop: -5,
        marginLeft: -10,
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 2,
        paddingBottom: 2,
        cursor: 'pointer'
    },
    checkboxWrapper: {
        display: 'flex',
        padding: 0
    },
    mapBlur: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        backgroundColor: 'rgba(221,221,221, 0.4)',
        '-webkit-backdrop-filter': 'blur(4px)',
        '-moz-backdrop-filter': 'blur(4px)',
        '-o-backdrop-filter': 'blur(4px)',
        '-ms-backdrop-filter': 'blur(4px)',
        backdropFilter: 'blur(4px)',
        color: 'black'
    },
    buttonBoxSection: {
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mobileIconPosition: {
        position: 'relative'
    },
    mobileFiterDetails: {
        position: 'absolute',
        left: 15,
        top: 0
    },
    appliedFiltersLabel: {
        backgroundColor: theme.primary,
        color: theme.textPrimaryReverted,
        borderRadius: theme.borderRadius10,
        border: theme.border,
        padding: 14
    },
    totalNumberFiltersWrapper: {
        position: 'relative'
    },
    totalNumberFilters: {
        color: 'white',
        position: 'absolute',
        top: -5,
        right: -6,
        fontSize: 10
    },
    resetButtonFloorPlanFiltersWrapper: {
        paddingRight: 16,
        paddingLeft: 16,
        paddingBottom: 8,
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
    }
}))

export const ListItemText = styled(ListItemTextDefault)(({ theme }) => ({
    '& .MuiListItemText-primary	': {
        fontSize: 13,
        fontFamily: theme.fontFamily,
        padding: '2px'
    }
}))

export const calendarIcon = {
    cursor: 'pointer',
    position: 'flex',
    top: '50%',
    justifyContent: 'left',
    alignItems: 'center'
}
